import React, { useState } from 'react';
import { ScanSearch, X } from 'lucide-react';
import { mockSongs, mockAlbums, mockArtists } from '../data/mockData';
import { Play } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Search = ({ onPlaySong }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  const navigate = useNavigate();

  const filteredSongs = mockSongs.filter(
    (song) =>
      song.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      song.artist.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredAlbums = mockAlbums.filter(
    (album) =>
      album.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      album.artist.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredArtists = mockArtists.filter((artist) =>
    artist.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const tabs = [
    { id: 'all', label: 'Todo' },
    { id: 'songs', label: 'Canciones' },
    { id: 'albums', label: 'Álbumes' },
    { id: 'artists', label: 'Artistas' }
  ];

  return (
    <div className="flex-1 overflow-y-auto pb-32 bg-gradient-to-br from-gray-50 via-white to-blue-50">
      <div className="p-8">
        {/* Search Header */}
        <div className="mb-8">
          <h1 className="text-5xl font-black text-gray-900 mb-6">Buscar</h1>
          <div className="relative max-w-2xl">
            <ScanSearch
              className="absolute left-5 top-1/2 transform -translate-y-1/2 text-gray-400"
              size={22}
            />
            <input
              type="text"
              placeholder="¿Qué quieres escuchar?"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-white text-gray-900 pl-14 pr-14 py-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#00CCFF] shadow-md transition-all duration-300 font-medium"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery('')}
                className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-[#00CCFF] transition-all duration-200 hover:scale-110"
              >
                <X size={22} />
              </button>
            )}
          </div>
        </div>

        {searchQuery ? (
          <>
            {/* Tabs */}
            <div className="flex gap-3 mb-8 border-b border-gray-200">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-6 py-3 font-bold transition-all duration-300 ${
                    activeTab === tab.id
                      ? 'text-[#00CCFF] border-b-2 border-[#00CCFF]'
                      : 'text-gray-500 hover:text-[#00CCFF]'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            {/* Results */}
            <div>
              {(activeTab === 'all' || activeTab === 'songs') && filteredSongs.length > 0 && (
                <section className="mb-8">
                  <h2 className="text-3xl font-black text-gray-900 mb-6">Canciones</h2>
                  <div className="space-y-2">
                    {filteredSongs.slice(0, activeTab === 'all' ? 5 : 50).map((song, index) => (
                      <div
                        key={song.id}
                        onClick={() => onPlaySong(song, filteredSongs)}
                        className="flex items-center gap-4 p-4 rounded-xl hover:bg-white transition-all duration-300 cursor-pointer group shadow-sm hover:shadow-lg transform hover:-translate-y-1"
                      >
                        <span className="text-gray-500 font-bold text-sm w-6">{index + 1}</span>
                        <img
                          src={song.cover}
                          alt={song.title}
                          className="w-14 h-14 rounded-xl object-cover shadow-md"
                        />
                        <div className="flex-1 min-w-0">
                          <h3 className="text-gray-900 font-bold truncate">{song.title}</h3>
                          <p className="text-sm text-gray-500 truncate">{song.artist}</p>
                        </div>
                        <span className="text-gray-500 text-sm font-medium">{song.duration}</span>
                        <button className="opacity-0 group-hover:opacity-100 transition-all duration-300 w-12 h-12 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center hover:scale-110 shadow-lg">
                          <Play size={18} className="text-white ml-0.5" fill="white" />
                        </button>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {(activeTab === 'all' || activeTab === 'albums') && filteredAlbums.length > 0 && (
                <section className="mb-8">
                  <h2 className="text-3xl font-black text-gray-900 mb-6">Álbumes</h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {filteredAlbums.slice(0, activeTab === 'all' ? 5 : 50).map((album) => (
                      <div
                        key={album.id}
                        onClick={() => navigate(`/album/${album.id}`)}
                        className="bg-white p-5 rounded-2xl transition-all duration-300 cursor-pointer group shadow-md hover:shadow-2xl transform hover:-translate-y-2"
                      >
                        <div className="relative mb-4 overflow-hidden rounded-xl">
                          <img
                            src={album.cover}
                            alt={album.title}
                            className="w-full aspect-square object-cover transform transition-transform duration-500 group-hover:scale-110"
                          />
                          <button className="absolute bottom-3 right-3 w-14 h-14 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 shadow-2xl hover:scale-110">
                            <Play size={22} className="text-white ml-0.5" fill="white" />
                          </button>
                        </div>
                        <h3 className="text-gray-900 font-bold mb-1 truncate">{album.title}</h3>
                        <p className="text-sm text-gray-500 truncate">{album.artist}</p>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {(activeTab === 'all' || activeTab === 'artists') && filteredArtists.length > 0 && (
                <section>
                  <h2 className="text-3xl font-black text-gray-900 mb-6">Artistas</h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                    {filteredArtists.slice(0, activeTab === 'all' ? 6 : 50).map((artist) => (
                      <div
                        key={artist.id}
                        onClick={() => navigate(`/artist/${artist.id}`)}
                        className="bg-white p-5 rounded-2xl transition-all duration-300 cursor-pointer group text-center shadow-md hover:shadow-2xl transform hover:-translate-y-2"
                      >
                        <div className="relative mb-4 overflow-hidden rounded-full">
                          <img
                            src={artist.image}
                            alt={artist.name}
                            className="w-full aspect-square object-cover transform transition-transform duration-500 group-hover:scale-110"
                          />
                          <button className="absolute bottom-2 right-2 w-12 h-12 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-300 shadow-2xl hover:scale-110">
                            <Play size={18} className="text-white ml-0.5" fill="white" />
                          </button>
                        </div>
                        <h3 className="text-gray-900 font-bold mb-1 truncate">{artist.name}</h3>
                        <p className="text-xs text-gray-500">{artist.genre}</p>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {filteredSongs.length === 0 &&
                filteredAlbums.length === 0 &&
                filteredArtists.length === 0 && (
                  <div className="text-center py-12">
                    <p className="text-gray-500 text-lg font-medium">No se encontraron resultados para "{searchQuery}"</p>
                  </div>
                )}
            </div>
          </>
        ) : (
          <div className="text-center py-16">
            <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-r from-[#00CCFF] to-[#056A84] rounded-full flex items-center justify-center">
              <ScanSearch size={48} className="text-white" />
            </div>
            <p className="text-gray-500 text-xl font-medium">Busca tu música cristiana favorita</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Search;
